<template>
  <div :class="['app-container', { 'bdc-profile-page': isBdc }]">
    <!-- BDC：单卡片 + 双列网格 -->
    <template v-if="isBdc">
      <el-card class="bdc-profile-card" shadow="never">
        <section class="bdc-profile-section bdc-profile-section--account">
          <h3 class="bdc-profile-section__title">账号信息</h3>
          <div class="bdc-profile-grid">
            <div class="bdc-profile-field">
              <span class="bdc-profile-field__label">手机绑定</span>
              <span v-if="userInfoData.phone" class="bdc-profile-field__text">{{ userInfoData.phone | phoneguolv }}</span>
            </div>
            <div class="bdc-profile-field">
              <span class="bdc-profile-field__label">邮箱绑定</span>
              <span v-if="userInfoData.email" class="bdc-profile-field__text">{{ userInfoData.email | phoneguolv }}</span>
            </div>
            <div class="bdc-profile-field">
              <span class="bdc-profile-field__label">账号类型</span>
              <div class="bdc-profile-field__value-row">
                <span>{{ userInfoData.attributes.authType | authType }}</span>
                <el-popover
                  v-if="userInfoData.attributes.isAuth == 0"
                  placement="right"
                  width="200"
                  trigger="hover"
                >
                  <span>请先完善个人信息</span>
                  <span slot="reference" class="bdc-profile-tag bdc-profile-tag--warning">未认证</span>
                </el-popover>
                <template v-else>
                  <span
                    v-if="userInfoData.attributes.company == '英雄互娱'"
                    class="bdc-profile-tag bdc-profile-tag--success"
                  >英雄</span>
                  <span v-else class="bdc-profile-tag bdc-profile-tag--success">非英雄</span>
                </template>
              </div>
            </div>
            <div class="bdc-profile-field">
              <span class="bdc-profile-field__label">账号ID</span>
              <span class="bdc-profile-field__text">{{ userInfoData.uid }}</span>
            </div>
            <div class="bdc-profile-field">
              <span class="bdc-profile-field__label">注册时间</span>
              <span class="bdc-profile-field__text">{{ userInfoData.createDate }}</span>
            </div>
          </div>
        </section>

        <div class="bdc-profile-divider" />

        <section class="bdc-profile-section bdc-profile-section--personal">
          <div class="bdc-profile-section__head">
            <h3 class="bdc-profile-section__title">
              个人信息{{ userInfoData.attributes.isAuth == 0 ? '（待完善）' : '（已完善）' }}
            </h3>
            <el-button
              v-if="!isEdit"
              type="text"
              class="bdc-profile-edit-btn"
              @click="handleEdit"
            >编辑</el-button>
          </div>

          <div v-if="!isEdit" class="bdc-profile-grid">
            <div class="bdc-profile-field">
              <span class="bdc-profile-field__label">真实姓名</span>
              <span v-if="userInfoData.realname" class="bdc-profile-field__text">{{ userInfoData.realname | realnames }}</span>
            </div>
            <div class="bdc-profile-field">
              <span class="bdc-profile-field__label">手机号</span>
              <span v-if="userInfoData.phone" class="bdc-profile-field__text">{{ userInfoData.phone | phoneguolv }}</span>
            </div>
            <div class="bdc-profile-field">
              <span class="bdc-profile-field__label">企业邮箱</span>
              <span v-if="userInfoData.email" class="bdc-profile-field__text">{{ userInfoData.email | phoneguolv }}</span>
            </div>
            <div class="bdc-profile-field">
              <span class="bdc-profile-field__label">所属公司</span>
              <span class="bdc-profile-field__text">{{ userInfoData.attributes.company }}</span>
            </div>
            <div class="bdc-profile-field">
              <span class="bdc-profile-field__label">所属部门</span>
              <span class="bdc-profile-field__text">{{ userInfoData.attributes.department }}</span>
            </div>
            <div class="bdc-profile-field">
              <span class="bdc-profile-field__label">职位</span>
              <span class="bdc-profile-field__text">{{ userInfoData.attributes.position }}</span>
            </div>
          </div>

          <el-form
            v-else
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            class="bdc-profile-form"
          >
            <div class="bdc-profile-grid">
              <el-form-item prop="realname" class="bdc-profile-form-item">
                <div class="bdc-profile-field">
                  <span class="bdc-profile-field__label"><span class="bdc-profile-field__required">*</span>真实姓名</span>
                  <div class="bdc-profile-field__control">
                    <el-input v-model="ruleForm.realname" />
                  </div>
                </div>
              </el-form-item>

              <el-form-item
                prop="phone"
                class="bdc-profile-form-item"
                :class="{ 'bdc-profile-form-item--full': userInfoData.attributes.isAuth == 0 && isPhoneCode }"
              >
                <div
                  class="bdc-profile-field"
                  :class="{ 'bdc-profile-field--stack': userInfoData.attributes.isAuth == 0 && isPhoneCode }"
                >
                  <span class="bdc-profile-field__label"><span class="bdc-profile-field__required">*</span>手机号</span>
                  <div class="bdc-profile-field__control">
                    <template v-if="userInfoData.attributes.isAuth == 0">
                      <el-input v-model="ruleForm.phone" @input="changePhone">
                        <el-select
                          v-model="ruleForm.phoneTop"
                          slot="prepend"
                          style="width:90px"
                          placeholder="请选择"
                          filterable
                          @input="changePhone"
                        >
                          <el-option
                            v-for="(item, index) in itcList"
                            :key="index"
                            :label="item.value + '           ' + item.label"
                            :value="item.value"
                          >
                            <span>{{ item.label }} {{ item.value }}</span>
                          </el-option>
                        </el-select>
                      </el-input>
                      <div v-if="isPhoneCode" class="bdc-profile-verify-row">
                        <el-button v-if="!isPhoneTimer" size="small" @click="handlePhone">获取验证码</el-button>
                        <el-button
                          v-if="isPhoneTimer"
                          size="small"
                          class="bdc-profile-timer-btn"
                        >{{ phonetTimes }} s</el-button>
                        <el-form-item prop="phoneCode" class="bdc-profile-inline-form-item">
                          <el-input v-model="ruleForm.phoneCode" placeholder="输入短信验证码" style="width: 130px;" />
                        </el-form-item>
                      </div>
                    </template>
                    <span v-else-if="userInfoData.phone" class="bdc-profile-field__text">{{ userInfoData.phone | phoneguolv }}</span>
                  </div>
                </div>
              </el-form-item>

              <el-form-item
                prop="email"
                class="bdc-profile-form-item"
                :class="{ 'bdc-profile-form-item--full': userInfoData.attributes.isAuth == 0 && isEmailCode }"
              >
                <div
                  class="bdc-profile-field"
                  :class="{ 'bdc-profile-field--stack': userInfoData.attributes.isAuth == 0 && isEmailCode }"
                >
                  <span class="bdc-profile-field__label"><span class="bdc-profile-field__required">*</span>企业邮箱</span>
                  <div class="bdc-profile-field__control">
                    <template v-if="userInfoData.attributes.isAuth == 0">
                      <el-input v-model="ruleForm.email" @input="changeEmail" />
                      <div v-if="isEmailCode" class="bdc-profile-verify-row">
                        <el-button v-if="!isEmailTimer" size="small" @click="handleEmail">获取验证码</el-button>
                        <el-button
                          v-if="isEmailTimer"
                          size="small"
                          class="bdc-profile-timer-btn"
                        >{{ emailTimes }} s</el-button>
                        <el-form-item prop="emailCode" class="bdc-profile-inline-form-item">
                          <el-input v-model="ruleForm.emailCode" placeholder="输入邮箱验证码" style="width: 130px;" />
                        </el-form-item>
                      </div>
                    </template>
                    <span v-else-if="userInfoData.email" class="bdc-profile-field__text">{{ userInfoData.email | phoneguolv }}</span>
                  </div>
                </div>
              </el-form-item>

              <el-form-item prop="company" class="bdc-profile-form-item">
                <div class="bdc-profile-field">
                  <span class="bdc-profile-field__label"><span class="bdc-profile-field__required">*</span>所属公司</span>
                  <div class="bdc-profile-field__control">
                    <el-input v-model="ruleForm.company" />
                  </div>
                </div>
              </el-form-item>

              <el-form-item prop="department" class="bdc-profile-form-item">
                <div class="bdc-profile-field">
                  <span class="bdc-profile-field__label"><span class="bdc-profile-field__required">*</span>所属部门</span>
                  <div class="bdc-profile-field__control">
                    <el-input v-model="ruleForm.department" />
                  </div>
                </div>
              </el-form-item>

              <el-form-item prop="position" class="bdc-profile-form-item">
                <div class="bdc-profile-field">
                  <span class="bdc-profile-field__label"><span class="bdc-profile-field__required">*</span>职位</span>
                  <div class="bdc-profile-field__control">
                    <el-input v-model="ruleForm.position" />
                  </div>
                </div>
              </el-form-item>
            </div>

            <div class="bdc-profile-actions">
              <el-button type="primary" class="bdc-profile-save-btn" @click="submitForm('ruleForm')">保存</el-button>
              <el-button class="bdc-profile-cancel-btn" @click="resetForm('ruleForm')">取消</el-button>
            </div>
          </el-form>
        </section>
      </el-card>
    </template>

    <!-- 非 BDC：保留原双卡片布局 -->
    <template v-else>
      <el-card class="box-card" shadow="never">
        <div slot="header" class="clearfix">
          <span class="header">账号信息</span>
        </div>
        <div class="list">
          <el-form label-width="150px" class="demo-ruleForm">
            <el-form-item label="手机绑定：">
              <span v-if="userInfoData.phone">{{ userInfoData.phone | phoneguolv }}</span>
            </el-form-item>

            <el-form-item label="邮箱绑定：">
              <span v-if="userInfoData.email">{{ userInfoData.email | phoneguolv }}</span>
            </el-form-item>

            <el-form-item label="账号类型：">
              <span>{{ userInfoData.attributes.authType | authType }}</span>
              <div class="mark">
                <el-popover placement="right" width="200" trigger="hover" v-if="userInfoData.attributes.isAuth == 0">
                  <span>请先完善个人信息</span>
                  <i slot="reference" style="cursor: pointer; color:#F56C6C" class="el-icon-warning">未认证</i>
                </el-popover>
                <template v-else>
                  <i class="el-icon-success" style="color:#67C23A" v-if="userInfoData.attributes.company == '英雄互娱'">英雄</i>
                  <i class="el-icon-success" style="color:#67C23A" v-else>非英雄</i>
                </template>
              </div>
            </el-form-item>

            <el-form-item label="账号ID：">
              <span>{{ userInfoData.uid }}</span>
            </el-form-item>

            <el-form-item label="注册时间：">
              <span>{{ userInfoData.createDate }}</span>
            </el-form-item>
          </el-form>
        </div>
      </el-card>

      <el-card class="box-card" shadow="never">
        <div slot="header" class="clearfix">
          <span class="header">个人信息{{ userInfoData.attributes.isAuth == 0 ? '（待完善）' : '（已完善）' }}</span>
          <el-button style="padding: 3px 10px 3px 20px" type="text" v-if="!isEdit" @click="handleEdit">编辑</el-button>
        </div>
        <div class="list">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" :class="!isEdit ? 'demo-ruleForm' : ''">
            <el-form-item label="真实姓名：" prop="realname">
              <div v-if="!isEdit"><span v-if="userInfoData.realname">{{ userInfoData.realname | realnames }}</span></div>
              <el-input v-model="ruleForm.realname" v-else size="small" style="width: 30%; max-width:300px" />
            </el-form-item>

            <el-form-item label="手机号：" prop="phone">
              <div v-if="!isEdit"><span v-if="userInfoData.phone">{{ userInfoData.phone | phoneguolv }}</span></div>
              <template v-else>
                <template v-if="userInfoData.attributes.isAuth == 0">
                  <el-input v-model="ruleForm.phone" size="small" style="width: 30%; max-width:300px" @input="changePhone">
                    <el-select v-model="ruleForm.phoneTop" slot="prepend" style="width:90px" placeholder="请选择" filterable @input="changePhone">
                      <el-option v-for="(item,index) in itcList" :key="index" :label="item.value+'           '+item.label" :value="item.value">
                        <span>{{ item.label }} {{ item.value }}</span>
                      </el-option>
                    </el-select>
                  </el-input>
                  <template v-if="isPhoneCode">
                    <el-button v-if="!isPhoneTimer" size="small" style="margin-left: 10px" @click="handlePhone">获取验证码</el-button>
                    <el-button v-if="isPhoneTimer" size="small" style="margin-left: 10px; min-width: 92px; color:#F56C6C; font-weight:bolder">{{ phonetTimes }} s</el-button>
                    <el-form-item prop="phoneCode" style="margin: 0 10px">
                      <el-input size="small" v-model="ruleForm.phoneCode" placeholder="输入短信验证码" style="width: 130px;" />
                    </el-form-item>
                  </template>
                </template>
                <div v-else><span v-if="userInfoData.phone">{{ userInfoData.phone | phoneguolv }}</span></div>
              </template>
            </el-form-item>

            <el-form-item label="企业邮箱：" prop="email">
              <div v-if="!isEdit"><span v-if="userInfoData.email">{{ userInfoData.email | phoneguolv }}</span></div>
              <template v-else>
                <template v-if="userInfoData.attributes.isAuth == 0">
                  <el-input v-model="ruleForm.email" size="small" style="width: 30%; max-width:300px" @input="changeEmail" />
                  <template v-if="isEmailCode">
                    <el-button v-if="!isEmailTimer" size="small" style="margin-left: 10px" @click="handleEmail">获取验证码</el-button>
                    <el-button v-if="isEmailTimer" size="small" style="margin-left: 10px; min-width: 92px; color:#F56C6C; font-weight:bolder">{{ emailTimes }} s</el-button>
                    <el-form-item prop="emailCode" style="margin: 0 10px">
                      <el-input size="small" v-model="ruleForm.emailCode" placeholder="输入邮箱验证码" style="width: 130px;" />
                    </el-form-item>
                  </template>
                </template>
                <div v-else><span v-if="userInfoData.email">{{ userInfoData.email | phoneguolv }}</span></div>
              </template>
            </el-form-item>

            <el-form-item label="所属公司：" prop="company">
              <span v-if="!isEdit">{{ userInfoData.attributes.company }}</span>
              <el-input v-model="ruleForm.company" v-else size="small" style="width: 30%; max-width:300px" />
            </el-form-item>

            <el-form-item label="所属部门：" prop="department">
              <span v-if="!isEdit">{{ userInfoData.attributes.department }}</span>
              <el-input v-model="ruleForm.department" v-else size="small" style="width: 30%; max-width:300px" />
            </el-form-item>

            <el-form-item label="职位：" prop="position">
              <span v-if="!isEdit">{{ userInfoData.attributes.position }}</span>
              <el-input v-model="ruleForm.position" v-else size="small" style="width: 30%; max-width:300px" />
            </el-form-item>

            <el-form-item v-if="isEdit">
              <el-button size="mini" type="primary" @click="submitForm('ruleForm')">保存</el-button>
              <el-button size="mini" @click="resetForm('ruleForm')">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { itcList } from "./components/itc"
import { ajax_userextramerge, ajax_sendSms, ajax_sendMail } from '@Sys~/api/sys'
const TIME_COUNT = 60; //更改倒计时时间
export default {
  data() {
    var phoneValidator = (rule, value, callback) => {
      if (this.userInfoData.attributes.isAuth == 0) {
        const regex = /[^\d]/;
        if (regex.test(value)) {
          this.ruleForm.phone = "";
          callback(new Error('请输入数字'));
        } else {
          var re = this.ruleForm.phoneTop == "+86" ? /^1[3456789]\d{9}$/ : /^\d{7,16}$/
          if (re.test(value)) {
            callback();
          } else {
            callback(new Error('请输入合法手机号'));
          }
        }
      } else {
        callback();
      }

    }
    return {
      value: "",
      isEdit: false, // 编辑
      itcList: itcList,

      ruleForm: {}, // 表单
      rules: {
        realname: [{ required: true, message: '请输入真实姓名', trigger: ['blur', 'change'] }],
        phone: [{ validator: phoneValidator, required: true, trigger: ['blur', 'change'] },
          // { pattern: /^1[3456789]\d{9}$/, message: "请输入合法手机号", trigger: ['blur', 'change'] }
        ],
        email: [{ required: true, message: '请输入企业邮箱', trigger: ['blur', 'change'] }, { type: 'email', message: '请输入合法邮箱地址', trigger: ['blur', 'change'] }],
        phoneCode: [{ required: true, message: '请输入短信验证码', trigger: ['blur', 'change'] }],
        emailCode: [{ required: true, message: '请输入邮箱验证码', trigger: ['blur', 'change'] }],
        company: [{ required: true, message: '请输入公司名称', trigger: ['blur', 'change'] }],
        department: [{ required: true, message: '请输入部门名称', trigger: ['blur', 'change'] }],
        position: [{ required: true, message: '请输入职位', trigger: ['blur', 'change'] }],
      },

      isPhoneCode: false,
      isEmailCode: false,

      isPhoneTimer: false,
      phonetTimes: TIME_COUNT,
      isEmailTimer: false,
      emailTimes: TIME_COUNT
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ]),

    isBdc() {
      return process.env.VUE_APP_PROJECT_TYPE === 'bdc'
    },

    userInfoData() {
      return JSON.parse(JSON.stringify(this.userInfo))
    }
  },

  filters: {
    phoneguolv(value) {
      value = value + "";
      var fstr = value.substring(0, 3);
      var lstr = value.substring(7, value.length);
      return fstr + "****" + lstr;
    },
    realnames(value) {
      value = value + "";
      var fstr = value.substring(0, 1);
      return fstr + "**";
    },

    authType(type) {
      const typeMap = {
        null: '个人账号',
        0: '个人账号',
        1: '企业账号'
      }
      return typeMap[type]
    }
  },

  methods: {
    // 修改密码跳转
    handleJump() {
      location.href = "https://auth.yingxiong.com/changePassword?service=" + encodeURIComponent(window.location.href)
    },

    // 编辑
    handleEdit() {
      this.isEdit = true
      this.ruleForm = { // JSON.parse(JSON.stringify(this.userInfoData))
        phoneTop: "+86",
        realname: this.userInfoData.realname,
        phone: this.userInfoData.phone,
        phoneCode: this.userInfoData.phoneCode,
        email: this.userInfoData.email,
        emailCode: this.userInfoData.emailCode,
        company: this.userInfoData.attributes.company,
        department: this.userInfoData.attributes.department,
        position: this.userInfoData.attributes.position
      }
      // console.log('=====',this.ruleForm)
      this.$nextTick(() => {
        this.$refs['ruleForm'].clearValidate()
      })

      // this.isPhoneCode = this.userInfoData.phone ? false : true
    },

    // 监听 手机号输入框
    changePhone(val) {
      this.isPhoneCode = false

      this.$refs['ruleForm'].validateField('phone', (valid) => {
        // console.log('验证手机号1111：',valid)
        if (!valid) {
          if (this.ruleForm.phone !== this.userInfo.phone) {
            this.isPhoneCode = true
          }
        }
      })
    },

    // 监听 邮箱输入框
    changeEmail(val) {
      this.isEmailCode = false

      this.$refs['ruleForm'].validateField('email', (valid) => {
        // console.log('验证email1111：',valid)
        if (!valid) {
          if (this.ruleForm.email !== this.userInfo.email) {
            this.isEmailCode = true
          }
        }
      })
    },

    // 获取短信验证码
    handlePhone() {
      if (!this.ruleForm.phone) {
        this.$refs['ruleForm'].validateField('phone')
        return
      }
      const data = {
        phone: this.ruleForm.phone,
        itc: this.ruleForm.phoneTop
      }
      ajax_sendSms(data).then(response => {
        if (response.code == 1) {
          // 倒计时
          this.phonetTimes = TIME_COUNT
          this.isPhoneTimer = setInterval(() => {
            if (this.phonetTimes > 0 && this.phonetTimes <= TIME_COUNT) {
              this.phonetTimes--
            } else {
              clearInterval(this.isPhoneTimer)
              this.isPhoneTimer = null
            }
          }, 1000);
        }
      })
    },

    // 获取邮箱验证码
    handleEmail() {
      if (!this.ruleForm.email) {
        this.$refs['ruleForm'].validateField('email')
        return
      }

      const data = {
        email: this.ruleForm.email
      }
      ajax_sendMail(data).then(response => {
        if (response.code == 1) {
          // 倒计时
          this.emailTimes = TIME_COUNT
          this.isEmailTimer = setInterval(() => {

            this.emailTimes--
            if (this.emailTimes === 0) {

              clearInterval(this.isEmailTimer)
              this.isEmailTimer = null
            }
          }, 1000);
        }
      })

    },

    // 保存
    submitForm(formName) {
      if (this.ruleForm.realname == this.ruleForm.phone || this.ruleForm.realname == this.ruleForm.email) {
        this.$message.warning("请填写正确姓名！");
        return false
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {

          let formData = new FormData()

          for (let key in this.ruleForm) {
            // console.log(key)
            this.ruleForm[key] = this.ruleForm[key] == null ? '' : this.ruleForm[key]
            formData.append(key, this.ruleForm[key])
          }

          ajax_userextramerge(formData).then(response => {
            if (response.code == 1) {
              this.$message({
                message: '认证提交成功',
                type: 'success'
              });

              this.isEdit = false

              this.$store.dispatch('user/getInfo') // 更新用户信息

              // 重新获取路由菜单
              if (process.env.VUE_APP_PROJECT_TYPE == 'file') {
                this.$store.dispatch('permission/generateRoutesFile').then(res => {
                  this.$router.addRoutes(res)
                })

              } else {
                this.$store.dispatch('permission/generateRoutesSys').then(res => {
                  this.$router.addRoutes(res)
                })
              }
            }
          })
        }
      })
    },

    // 取消
    resetForm(formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].resetFields()
      }
      this.ruleForm = {
        realname: this.userInfoData.realname,
        phone: this.userInfoData.phone,
        phoneCode: this.userInfoData.phoneCode,
        email: this.userInfoData.email,
        emailCode: this.userInfoData.emailCode,
        company: this.userInfoData.attributes.company,
        department: this.userInfoData.attributes.department,
        position: this.userInfoData.attributes.position
      }
      this.isPhoneCode = false
      this.isEmailCode = false
      this.isEdit = false
    },
  }
}
</script>

<style lang="scss" scoped>
.app-container:not(.bdc-profile-page) {
  .box-card {
    border: none;
    margin: 0 auto;
    width: 80%;
    .header {
      font-weight: bolder;
    }
    ::v-deep .el-card__header {
      padding: 10px 20px;
      border-bottom: none;
    }
    ::v-deep .el-card__body {
      padding: 5px 20px;
    }
    ::v-deep .el-form-item__content {
      display: flex;
      justify-content: start;
      align-items: center;
    }
    .mark {
      margin-left: 30px;
      i::before {
        padding-right: 3px;
      }
    }
    .demo-ruleForm {
      ::v-deep .el-form-item {
        margin-bottom: 10px;
      }
    }
  }
}

::v-deep .el-input-group__prepend {
  background-color: #fff;
}
</style>
